import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAnnouncement } from "models/IAnnouncement";

export interface IAnnouncementsState {
  value: IAnnouncement[];
  isLoading: boolean;
  isLoaded: boolean;
}

const initialState: IAnnouncementsState = {
  value: [],
  isLoading: true,
  isLoaded: false,
};

export const announcementsSlice = createSlice({
  name: "announcements",
  initialState,
  reducers: {
    setAnnouncements: (state, action: PayloadAction<IAnnouncement[]>): void => {
      state.value = action.payload;
      state.isLoading = false;
      state.isLoaded = true;
    },
    addAnnouncement: (state, action: PayloadAction<IAnnouncement>): void => {
      state.value.push(action.payload);
    },
    updateAnnouncementInSlice: (
      state,
      action: PayloadAction<IAnnouncement>,
    ): void => {
      const index: number = state.value.findIndex(
        (announcement: IAnnouncement): boolean =>
          announcement.id === action.payload.id,
      );
      if (index !== -1) {
        state.value[index] = action.payload;
      }
    },
    removeAnnouncement: (state, action: PayloadAction<string>): void => {
      state.value = state.value.filter(
        (announcement: IAnnouncement): boolean =>
          announcement.id !== action.payload,
      );
    },
  },
});

export const {
  setAnnouncements,
  addAnnouncement,
  updateAnnouncementInSlice,
  removeAnnouncement,
} = announcementsSlice.actions;

export default announcementsSlice.reducer;
